import React from 'react';
import { SelectedSubscription } from './SubscriptionToProjectWizardTypes';

interface Step2Props {
    subscriptions: SelectedSubscription[];
    setSubscriptions: React.Dispatch<React.SetStateAction<SelectedSubscription[]>>;
    searchQuery: string;
    setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
}

const SubscriptionToProjectWizardStep2: React.FC<Step2Props> = ({
    subscriptions,
    setSubscriptions,
    searchQuery,
    setSearchQuery
}) => {
    const formatPrice = (cents: number) => {
        return `${(cents / 100).toFixed(2)} €`;
    };

    const toggleSubscription = (id: number) => {
        setSubscriptions(subscriptions.map(s =>
            s.subscription.id === id ? { ...s, selected: !s.selected } : s
        ));
    };

    const selectAll = () => {
        setSubscriptions(subscriptions.map(s => ({ ...s, selected: true })));
    };

    const deselectAll = () => {
        setSubscriptions(subscriptions.map(s => ({ ...s, selected: false })));
    };

    const filteredSubscriptions = subscriptions.filter(s => {
        if (!searchQuery) return true;
        const query = searchQuery.toLowerCase();
        const description = s.subscription.description?.toLowerCase() || '';
        const rtName = s.subscription.ownerRoundTable?.name.toLowerCase() || '';
        const rtNumber = s.subscription.ownerRoundTable?.number.toString() || '';
        return description.includes(query) || rtName.includes(query) || rtNumber.includes(query);
    });

    const selectedCount = subscriptions.filter(s => s.selected).length;

    return (
        <div className="subToProjWiz-wizard-step">
            <h3>Abonnements auswählen</h3>
            <p className="subToProjWiz-step-description">
                Wählen Sie die Abonnements aus, die in das Projekt aufgenommen werden sollen.
            </p>

            <div className="subToProjWiz-subscription-selection-header">
                <div className="subToProjWiz-selection-actions">
                    <button
                        type="button"
                        className="subToProjWiz-wizard-btn subToProjWiz-wizard-btn-secondary"
                        onClick={selectAll}
                    >
                        Alle auswählen
                    </button>
                    <button
                        type="button"
                        className="subToProjWiz-wizard-btn subToProjWiz-wizard-btn-secondary"
                        onClick={deselectAll}
                    >
                        Alle abwählen
                    </button>
                    <span className="subToProjWiz-selection-count">
                        {selectedCount} von {subscriptions.length} ausgewählt
                    </span>
                </div>

                <div className="subToProjWiz-search-box">
                    <input
                        type="text"
                        className="subToProjWiz-form-control"
                        placeholder="Abonnements durchsuchen..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
            </div>

            <div className="subToProjWiz-subscription-list">
                {filteredSubscriptions.length === 0 ? (
                    <div className="subToProjWiz-no-subscriptions">
                        {searchQuery ? 'Keine Abonnements gefunden.' : 'Keine Abonnements verfügbar.'}
                    </div>
                ) : (
                    filteredSubscriptions.map(({ subscription, selected }) => (
                        <div
                            key={subscription.id}
                            className={`subToProjWiz-subscription-item ${selected ? 'selected' : ''}`}
                            onClick={() => toggleSubscription(subscription.id)}
                        >
                            <div className="subToProjWiz-subscription-checkbox">
                                <input
                                    type="checkbox"
                                    checked={selected}
                                    onChange={() => toggleSubscription(subscription.id)}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </div>
                            <div className="subToProjWiz-subscription-details">
                                <div className="subToProjWiz-subscription-description">
                                    {subscription.description || 'Keine Beschreibung'}
                                </div>
                                <div className="subToProjWiz-subscription-meta">
                                    {subscription.ownerRoundTable ? (
                                        <span className="subToProjWiz-subscription-owner">
                                            RT {subscription.ownerRoundTable.number} - {subscription.ownerRoundTable.name}
                                        </span>
                                    ) : (
                                        <span className="subToProjWiz-subscription-owner-none">
                                            Kein Round Table zugeordnet
                                        </span>
                                    )}
                                    <span className="subToProjWiz-subscription-price">
                                        {formatPrice(subscription.annualPrice)} / Jahr
                                    </span>
                                    <span className="subToProjWiz-subscription-tax">
                                        MwSt: {subscription.taxRate}%
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default SubscriptionToProjectWizardStep2;
